var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PageHeading", {
        attrs: {
          text: _vm.eventCategory.title
            ? `События: ${_vm.eventCategory.title}`
            : _vm.$t("pages-name.parent.events"),
          mode: "grid",
          "grid-data-loading": _vm.gridDataLoading,
          "results-count": _vm.resultsCount,
        },
        scopedSlots: _vm._u(
          [
            {
              key: `toolbar.prepend`,
              fn: function () {
                return [
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      !_vm.categorySlug && _vm.eventCategories.length
                        ? _c("v-select", {
                            attrs: {
                              "hide-details": "",
                              dense: "",
                              outlined: "",
                              "item-text": "title",
                              "item-value": "id",
                              "return-object": "",
                              label: "Создать событие",
                              items: _vm.eventCategories,
                            },
                            on: { change: _vm.createEvent },
                          })
                        : _c(
                            "v-btn",
                            {
                              staticClass: "mx-2 mt-2",
                              attrs: {
                                link: "",
                                small: "",
                                outlined: "",
                                color: "primary",
                                to: {
                                  name: "page-event-new",
                                  params: { categorySlug: _vm.categorySlug },
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-2", attrs: { small: "" } },
                                [_vm._v(" mdi-plus ")]
                              ),
                              _vm._v(" Создать событие "),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "v-row",
        { staticClass: "mt-4" },
        [
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("span", [_vm._v("Фильтр событий")]),
              _c("v-select", {
                attrs: {
                  outlined: "",
                  "item-text": "title",
                  "item-valugridPageInterfacee": "value",
                  "hide-details": "",
                  dense: "",
                  value: _vm.filter,
                  items: _vm.$options.filtersOptional,
                },
                on: {
                  input: function ($event) {
                    _vm.filter = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm.filter === "custom"
            ? _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c("span", [_vm._v("Дата начала")]),
                  _c(
                    "v-menu",
                    {
                      ref: "menuStartDate",
                      attrs: {
                        "close-on-content-click": false,
                        "min-width": "auto",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "v-row",
                                  {
                                    attrs: {
                                      align: "center",
                                      "no-gutters": "",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-text-field",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: {
                                              "hide-details": "",
                                              outlined: "",
                                              readonly: "",
                                              dense: "",
                                              value: _vm.preparedFormatTime(
                                                _vm.startDate
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.startDate = $event
                                              },
                                            },
                                          },
                                          "v-text-field",
                                          attrs,
                                          false
                                        ),
                                        on
                                      )
                                    ),
                                    _c("v-icon", { staticClass: "ml-2" }, [
                                      _vm._v("mdi-calendar"),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3955452762
                      ),
                      model: {
                        value: _vm.menuStartDate,
                        callback: function ($$v) {
                          _vm.menuStartDate = $$v
                        },
                        expression: "menuStartDate",
                      },
                    },
                    [
                      _c("v-date-picker", {
                        attrs: {
                          "no-title": "",
                          scrollable: "",
                          "first-day-of-week": "1",
                          value: _vm.startDate,
                        },
                        on: {
                          change: function ($event) {
                            _vm.startDate = $event
                          },
                          input: function ($event) {
                            _vm.menuStartDate = false
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("span", [_vm._v("Дата окончания")]),
              _c(
                "v-menu",
                {
                  ref: "menuEndDate",
                  attrs: {
                    "close-on-content-click": false,
                    disabled: !_vm.startDate,
                    "min-width": "auto",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-row",
                            { attrs: { align: "center", "no-gutters": "" } },
                            [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: {
                                        "hide-details": "",
                                        outlined: "",
                                        readonly: "",
                                        dense: "",
                                        value: _vm.preparedFormatTime(
                                          _vm.endDate
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.endDate = $event
                                        },
                                      },
                                    },
                                    "v-text-field",
                                    attrs,
                                    false
                                  ),
                                  on
                                )
                              ),
                              _c("v-icon", { staticClass: "ml-2" }, [
                                _vm._v("mdi-calendar"),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.menuEndDate,
                    callback: function ($$v) {
                      _vm.menuEndDate = $$v
                    },
                    expression: "menuEndDate",
                  },
                },
                [
                  _c("v-date-picker", {
                    attrs: {
                      "no-title": "",
                      scrollable: "",
                      "first-day-of-week": "1",
                      min: _vm.startDate,
                      value: _vm.endDate,
                    },
                    on: {
                      change: function ($event) {
                        _vm.endDate = $event
                      },
                      input: function ($event) {
                        _vm.menuEndDate = false
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("GridEvents", {
                ref: "grid",
                attrs: { category: _vm.eventCategory, filter: _vm.getFilter },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }